<script setup lang="ts">
import type { IProps } from './MoreAbout.types'
defineProps<IProps>()
</script>

<template>
  <UiSection
    color="white"
    class="more-about"
  >
    <UiHeader
      v-if="header"
      :header="header"
      header-size="h6"
    />
    
    <div class="more-about__content">
      <UiButton
        v-for="(item, index) in items"
        :key="`more-about-our-approach-${index}`"
        :to="$t(item.to!)"
        :target="item.target || '_self'"
        :variant="item.variant || 'secondary'"
      >
        {{ $t(item.text) }}
      </UiButton>
    </div>
  </UiSection>
</template>

<style lang="scss" scoped>
:deep(.button.button--secondary) {
  border-radius: 8px;
}

:deep(.ui-header) {
  margin-bottom: 4.8rem
}

.more-about {
  @include section-centered;
  padding-top: 4.8rem;
  padding-bottom: 4.8rem;
  border-bottom: 1px solid $gray-300;
  border-radius: 0;

  &__content {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1.6rem;
  }
}

@include atM {
  .more-about {
    padding-top: 9.6rem;
    padding-bottom: 9.6rem;
  }
}
</style>
